import VueRouter from 'vue-router';
import Vue from 'vue';
import Hall from '../views/Hall';
import SPA from '../views/SPAEntrance';
import pageViewTrackHelper from '../services/page.track.service';
import NotFound from '../views/NotFound.vue';
Vue.use(VueRouter);
const routes = [
  {
    path: '/:dealerId/:source/index.html',
    component: Hall,
    meta: {
      track: {
        subcategory: 18491,
        extend: {
          dealer: ':dealerId',
          dealer_id: ':dealerId',
          dealerId: ':dealerId',
          pvareaid: ':pvareaid',
        },
      },
    },
  },
  {
    path: '/icsapp/entrance',
    component: () => import(/* webpackChunkName: "IcsAppEntrance" */ '../views/IcsAppEntrance'),
    meta: {
      track: function (route) {
        if (route.query.busi === 'vrShareTask') {
          return { subcategory: 24860 };
        }
        return { subcategory: 18491 };
      },
    },
  },
  {
    // 应该多入口问题，之后添加其他页面入口统一使用spa开始，在节点children 中添加子页面
    path: '/spa',
    component: SPA,
    children: [
      //活动页分享
      {
        path: 'activityShare/:dealerId',
        component: () =>
          import(
            /* webpackChunkName: "sharespa-activity" */ '../views/shareSpa/activity.vue'
          ),
        meta: {
          track: {
            subcategory: 18491,
          },
        },
      },
    ],
  },
  {
    // 会匹配所有路径
    path: '*',
    component:NotFound
  }
];
const router = new VueRouter({
  mode: 'history',
  routes: routes,
  base: '/vr/',
});
router.afterEach((to) => {
  if (!to) {
    return;
  }

  new Promise(function (resolve) {
    setTimeout(function () {
      resolve(true);
    }, 0);
  }).then(function () {
    if (to.meta) {
      // 上报埋点
      if (to.meta.track) {
        if (typeof to.meta.track === 'function') {
          to.meta.track = to.meta.track(to);
        }
        const trackVars = to.meta.track;
        const extend = to.meta.track.extend || {};
        const tempPGVars = {};
        for (const key in extend) {
          const value = extend[key].toString();
          if (!value) {
            continue;
          }
          const action = value[0];
          const param = value.substr(1);
          if (action === ':') {
            tempPGVars[key] = to.params[param];
          } else if (action === '?') {
            tempPGVars[key] = to.query[param];
          } else {
            tempPGVars[key] = value;
          }
        }
        if (to.params && to.params['dealerId']) {
          pageViewTrackHelper.setDefaultTrackVar({
            dealer: to.params['dealerId'],
          });
        }
        pageViewTrackHelper.trackPageView(trackVars, tempPGVars);
      }
    }
  });
});

export { router };
